var formatAmount=function(amount,currencyPrecision){return amount.toFixed(currencyPrecision)};export default formatAmount;
//# sourceMappingURL=formatAmount.js.map